export default {
	showCancelSubscription: false,
}
